export const spacingClasses = {
  types: {
    m: 'Margin',
    p: 'Padding',
  },
  positions: {
    t: 'Top',
    l: 'Left',
    r: 'Right',
    b: 'Bottom',
    x: 'Horizontal',
    y: 'Vertical',
    a: 'All',
  },
  values: {
    0: '0px',
    auto: 'Auto',
    xs: '$spacer-xs ~ 4px',
    sm: '$spacer-sm ~ 8px',
    md: '$spacer-md ~ 12px',
    '': '$spacer ~ 16px',
    lg: '$spacer-lg ~ 20px',
    xl: '$spacer-xl ~ 24px',
    xxl: '$spacer-xxl ~ 32px',
    '3xl': '$spacer-3xl ~ 64px',
  },
};

export const colorClasses = {
  palettes: {
    primary: 'Primary',
    accent: 'Accent',
    warn: 'Warn',
    black: 'Black',
  },
  hues: {
    50: '50',
    100: '100',
    200: '200',
    300: '300',
    400: '400',
    500: '500',
    600: '600',
    700: '700',
    800: '800',
    900: '900',
  },
  types: {
    bg: 'Background',
    text: 'Text',
    'bg-hover': 'Background Hover',
  },
};

export const textClasses = {
  'cipo-text': {
    name: 'Predefined',
    values: {
      info: 'Info (12px, 700)',
      label: 'Label (10px, 500)',
      'bold-sm': 'Bold Small (12px, 700)',
      'bold-md': 'Bold Medium (14px, 700)',
      'bold-lg': 'Bold Large (16px, 700)',
      'medium-sm': 'Medium Small (12px, 500)',
      'medium-md': 'Medium Medium (14px, 500)',
      'medium-lg': 'Medium Large  (16px, 500)',
      'medium-xl': 'Medium Extra Large (18px, 500)',
      'regular-sm': 'Regular Small (12px, 400)',
      'regular-md': 'Regular Medium (14px, 400)',
      'regular-lg': 'Regular Large (16px, 400)',
    },
  },
  'cipo--text-weight': {
    name: 'Weight',
    values: {
      light: 'Light (300)',
      regular: 'Regular (400)',
      medium: 'Medium (500)',
      bold: 'Bold (700)',
      black: 'Black (900)',
    },
  },
  'cipo--text-size': {
    name: 'Size',
    values: {
      xs: 'Extra Small (10px)',
      sm: 'Small (12px)',
      md: 'Medium (14px)',
      lg: 'Large (16px) This is the default size',
      xl: 'Extra Large (18px)',
      h6: 'Heading 6 (18px)',
      h5: 'Heading 5 (20px)',
      h4: 'Heading 4 (22px)',
      h3: 'Heading 3 (24px)',
      h2: 'Heading 2 (26px)',
      h1: 'Heading 1 (28px)',
    },
  },
  'cipo--text-height': {
    name: 'Height',
    values: {
      sm: 'Small (100%',
      md: 'Medium (120%)',
      lg: 'Large (150%)',
    },
  },
  'cipo--text': {
    name: 'Text (Miscellaneous)',
    values: {
      uppercase: 'Uppercase',
      lowercase: 'Lowercase',
      center: 'Center',
      end: 'End',
      ellipsed: 'Ellipsed',
      clip: 'Clip',
      pre: 'Pre',
      highlight: 'Highlight',
      'pre-line': 'Pre-line',
    },
  },
};

const types = {
  lite: 'Lite',
  solid: 'Solid',
  dashed: 'Dashed',
  dotted: 'Dotted',
};

export const borderClasses = {
  '-radius': {
    name: 'Radius',
    values: {
      xs: 'Extra Small (4px)',
      sm: 'Small (8px)',
      md: 'Medium (12px)',
      circle: 'Circle (50%)',
    },
  },
  '-top': {
    name: 'Top',
    values: types,
  },
  '-left': {
    name: 'Left',
    values: types,
  },
  '-right': {
    name: 'Right',
    values: types,
  },
  '-bottom': {
    name: 'Bottom',
    values: types,
  },
  '': {
    name: 'All',
    values: types,
  },
  '-color': {
    name: 'Color',
    values: {
      primary: 'Primary',
      accent: 'Accent',
      warn: 'Warn',
    },
  },
};

export const generalClasses = {
  width: {
    name: 'Width',
    values: {
      auto: 'Auto',
      full: 'Full',
      'fit-content': 'Fit Content',
    },
  },
  height: {
    name: 'Height',
    values: {
      auto: 'Auto',
      full: 'Full',
      'fit-content': 'Fit Content',
    },
  },
  overflow: {
    name: 'Overflow',
    values: {
      hidden: 'Hidden',
      auto: 'Auto',
      'x-auto': 'X Auto',
      'y-auto': 'Y Auto',
    },
  },
  display: {
    name: 'Display',
    values: {
      block: 'Block',
      'inline-block': 'Inline block',
      none: 'None',
    },
  },
  visibility: {
    name: 'Visibility',
    values: {
      hidden: 'Hidden',
    },
  },
  cursor: {
    name: 'Cursor',
    values: {
      pointer: 'Pointer',
      default: 'Default',
      move: 'Move',
      help: 'Help',
    },
  },
  position: {
    name: 'Position',
    values: {
      relative: 'Relative',
      absolute: 'Absolute',
      fixed: 'Fixed',
      sticky: 'Sticky',
    },
  },
};

const alignValues = {
  start: 'Start',
  center: 'Center',
  end: 'End',
  stretch: 'Stretch',
  baseline: 'Baseline',
};

export const layoutClasses = {
  flex: {
    name: 'Flex container (fxLayout)',
    prefix: 'cipo--flex--',
    target: 'container',
    values: {
      row: 'Row',
      column: 'Column',
      wrap: 'Wrap',
      nowrap: 'No wrap',
    },
  },
  'flex-item': {
    name: 'Flex item (fxFlex)',
    prefix: 'cipo--flex--',
    target: 'item',
    values: {
      1: 'fxFlex',
      auto: 'fxFlex="auto"',
      none: 'fxFlex="none"',
      25: 'fxFlex="25"',
      33: 'fxFlex="33"',
      50: 'fxFlex="50"',
      66: 'fxFlex="66"',
      75: 'fxFlex="75"',
      100: 'fxFlex="100"',
    },
  },
  justify: {
    name: 'Justify content (fxLayoutAlign main)',
    prefix: 'cipo--justify--',
    target: 'container',
    values: {
      start: 'Start',
      center: 'Center',
      end: 'End',
      between: 'Space between',
      around: 'Space around',
      evenly: 'Space evenly',
    },
  },
  align: {
    name: 'Align items (fxLayoutAlign cross)',
    prefix: 'cipo--align--',
    target: 'container',
    values: alignValues,
  },
  'align-self': {
    name: 'Align self (fxFlexAlign)',
    prefix: 'cipo--align-self--',
    target: 'item',
    values: alignValues,
  },
  grid: {
    name: 'Grid columns',
    prefix: 'cipo--grid--cols-',
    target: 'grid',
    values: {
      1: '1',
      2: '2',
      3: '3',
      4: '4',
      5: '5',
      6: '6',
    },
  },
  'col-span': {
    name: 'Grid column span',
    prefix: 'cipo--col-span--',
    target: 'grid-item',
    values: {
      1: '1',
      2: '2',
      3: '3',
      4: '4',
      full: 'Full row',
    },
  },
  display: {
    name: 'Display (fxHide / fxShow)',
    prefix: 'cipo--display--',
    target: 'item',
    values: {
      none: 'None',
      block: 'Block',
    },
  },
};

export const layoutTiers = {
  '': 'All screens',
  '--tablet': 'Tablet and phone (< 980px, fx lt-lg)',
  '--phone': 'Phone (< 660px, fx lt-md)',
};

export const layoutTierPreviewWidths: Record<string, number> = {
  '': 1000,
  '--tablet': 800,
  '--phone': 480,
};
